import {
  formatLocalizedDateMonth,
  shortDayNameFormatter,
  timeFormatter,
  yearFormatter
} from '@hconnect/uikit/src/common/utils/dateformatting'
import {Moment} from 'moment'

/**
 *
 * Function which returns localized date time, example: "YYYY ddd DD/MM, HH:mm"
 * (year, short day name, day of month, hours and minutes)
 */
export const getLocalizedYearDayMonthTime = (
  datetime: Moment,
  timezoneId: string,
  locale: string
): string => {
  const timezoneOffset = datetime.tz(timezoneId).utcOffset()

  const year = yearFormatter(datetime, locale, timezoneOffset)
  const shortDayName = shortDayNameFormatter(datetime, locale, timezoneOffset)
  const dateMonth = formatLocalizedDateMonth(datetime, locale)
  const time = timeFormatter(datetime, locale, timezoneOffset)

  return `${year} ${shortDayName} ${dateMonth}, ${time}`
}
